import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  return <footer className="bg-navy-950 text-white relative overflow-hidden" data-id="element-223">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-224">
        <div className="absolute -top-20 right-0 w-96 h-96 bg-blue-500 rounded-full opacity-5 blur-3xl" data-id="element-225"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-blue-400 rounded-full opacity-5 blur-3xl" data-id="element-226"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10" data-id="element-227">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8" data-id="element-228">
          {/* Logo and Description - Takes up more space */}
          <div className="lg:col-span-4" data-id="element-229">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aWSGtaZkMPMFTvksK3S2Vo/SS-Horizontal-Lockup_River-Royale.webp" alt="SmartSoda" className="h-12 mb-6" width="180" height="48" loading="lazy" decoding="async" data-id="element-230" />
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-231">
              Transforming beverage experiences with premium, sustainable
              solutions for modern businesses.
            </p>
            <div className="flex items-start space-x-3" data-id="element-232">
              <div className="flex-shrink-0 mt-1" data-id="element-233">
                <svg className="h-5 w-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-234">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-235" />
                </svg>
              </div>
              <div data-id="element-236">
                <p className="text-sm text-gray-500 mb-1" data-id="element-237">Contact Us</p>
                <a href="mailto:office@smartsoda.com" className="text-gray-300 hover:text-blue-400 transition-colors" data-id="element-238">
                  office@smartsoda.com
                </a>
              </div>
            </div>
          </div>
          {/* Solutions Column */}
          <div className="lg:col-span-2" data-id="element-239">
            <h3 className="text-lg font-semibold mb-6 text-white relative inline-block" data-id="element-240">
              Solutions
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-blue-500" data-id="element-241"></span>
            </h3>
            <ul className="space-y-4" data-id="element-242">
              <li data-id="element-243">
                <a href="https://restaurant.smartsoda.com" className="text-gray-400 hover:text-blue-400 transition-colors flex items-center group" data-id="element-244">
                  <span className="mr-2 text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-245">
                    →
                  </span>
                  Restaurants
                </a>
              </li>
              <li data-id="element-246">
                <a href="https://breakrooms.smartsoda.com" className="text-gray-400 hover:text-blue-400 transition-colors flex items-center group" data-id="element-247">
                  <span className="mr-2 text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-248">
                    →
                  </span>
                  Breakrooms
                </a>
              </li>
              <li data-id="element-249">
                <a href="https://spa.smartsoda.com" className="text-gray-400 hover:text-blue-400 transition-colors flex items-center group" data-id="element-250">
                  <span className="mr-2 text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-251">
                    →
                  </span>
                  Spas
                </a>
              </li>
              <li data-id="element-252">
                <a href="https://showroom.smartsoda.com" className="text-gray-400 hover:text-blue-400 transition-colors flex items-center group" data-id="element-253">
                  <span className="mr-2 text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-254">
                    →
                  </span>
                  Showrooms
                </a>
              </li>
            </ul>
          </div>
          {/* Why SmartSoda Column */}
          <div className="lg:col-span-3" data-id="element-255">
            <h3 className="text-lg font-semibold mb-6 text-white relative inline-block" data-id="element-256">
              Why SmartSoda
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-blue-500" data-id="element-257"></span>
            </h3>
            <ul className="space-y-4" data-id="element-258">
              <li className="flex items-start" data-id="element-259">
                <svg className="h-5 w-5 text-blue-400 mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-260">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-261" />
                </svg>
                <span className="text-gray-400 text-sm" data-id="element-262">
                  Premium clean-label ingredients
                </span>
              </li>
              <li className="flex items-start" data-id="element-263">
                <svg className="h-5 w-5 text-blue-400 mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-264">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-265" />
                </svg>
                <span className="text-gray-400 text-sm" data-id="element-266">
                  Sustainable & eco-friendly
                </span>
              </li>
              <li className="flex items-start" data-id="element-267">
                <svg className="h-5 w-5 text-blue-400 mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-268">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-269" />
                </svg>
                <span className="text-gray-400 text-sm" data-id="element-270">
                  60%+ profit margins
                </span>
              </li>
              <li className="flex items-start" data-id="element-271">
                <svg className="h-5 w-5 text-blue-400 mr-2 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-272">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-273" />
                </svg>
                <span className="text-gray-400 text-sm" data-id="element-274">
                  IoT inventory management
                </span>
              </li>
            </ul>
          </div>
          {/* CTA Column */}
          <div className="lg:col-span-3" data-id="element-275">
            <h3 className="text-lg font-semibold mb-6 text-white relative inline-block" data-id="element-276">
              Get Started
              <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-blue-500" data-id="element-277"></span>
            </h3>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed" data-id="element-278">
              Ready to transform your beverage experience? Schedule a free demo
              today.
            </p>
            <a href="#book-demo" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-sm font-medium rounded-lg text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all shadow-lg hover:shadow-xl transform hover:scale-105" data-id="element-279">
              Book Free Demo
              <svg className="ml-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-280">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" data-id="element-281" />
              </svg>
            </a>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-gray-800" data-id="element-282">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-283">
            <p className="text-gray-500 text-sm" data-id="element-284">
              &copy; {new Date().getFullYear()} SmartSoda, Inc. All rights
              reserved.
            </p>
            <div className="flex items-center space-x-6" data-id="element-285">
              <span className="text-gray-500 text-sm flex items-center" data-id="element-286">
                <svg className="h-4 w-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20" data-id="element-287">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-288" />
                </svg>
                Trusted by 500+ businesses
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;